<app-loader *ngIf="isDisabled"></app-loader>
<div class="card" style="min-height: 100%;">
    <div class="card-header">
        <div class="row">
            <div class="col">
                Employee Confirmation {{GetID == 1?'Approval':'Request'}}
            </div>
            <div class="col-auto">
                <span class="badge"
                    [ngClass]="{'success': common.ToLowerCase(DetailData.ApprovalStatus) == 'approved', 'danger':common.ToLowerCase(DetailData.ApprovalStatus) == 'rejected','warning':common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' || common.ToLowerCase(DetailData.ApprovalStatus) == 'reInitiated' || common.ToLowerCase(DetailData.ApprovalStatus) == 'pendingwithsenior'}">{{StatusReplace(DetailData.ApprovalStatus)}}</span>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="row g-0">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body p-1">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="row" style="align-items: center;line-height: normal;">
                                    <div class="col-2">
                                        <img *ngIf="DetailData.Photo != null && DetailData.Photo != ''" mat-card-image
                                            class="userImage" [src]="common.PhotoLink(DetailData.Photo)" />
                                        <div *ngIf="DetailData.Photo == null || DetailData.Photo == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(DetailData.EmployeeName)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <label class="form-label"
                                            style="font-size: 13px!important;font-weight: 500; margin-bottom: 0;color: #191d4a;">{{DetailData.EmployeeName}}</label><br />
                                        <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">#{{DetailData.EmpCode}}</label><br />
                                        <!-- <label class="form-label"
                                            style="font-size: 10px!important;font-weight: 500; margin-bottom: 0;color: #aaaab2;">{{DetailData.DesignationName}}</label> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col"></div>
                            <div class="col-auto text-end">
                                <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate}}</label>
                            </div>
                        </div>
                        <div style="background-color:#0078d42e;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-4">
                                    <label for="RequestDate" class="text-label-light">Request Date</label> <br />
                                    <label name="RequestDate" class="text-label-dark">{{DetailData.RequestDate
                                        }}</label>
                                </div>
                                <div class="col-md-4">
                                    <label for="JoiningDate" class="text-label-light">Joining Date</label> <br />
                                    <label name="JoiningDate" class="text-label-dark">{{DetailData.JoiningDate
                                        }}</label>
                                </div>
                                <div class="col-md-4">
                                    <label for="ConfirmationDate" class="text-label-light">Confirmation Date</label>
                                    <br />
                                    <label name="ConfirmationDate" class="text-label-dark">{{DetailData.ConfirmationDate
                                        }}</label>
                                </div>
                            </div>
                        </div>
                        <div style="background-color:#8080800f;border-radius: 5px;" class="p-2 mb-2">
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?'Client Location' :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?'Branch':''}}</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{common.ToLowerCase(DetailData.EmpType)
                                        ==
                                        'front'?DetailData.ClientLocation :common.ToLowerCase(DetailData.EmpType) ==
                                        'back'?DetailData.BranchName:''}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Initiator
                                        Name</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.InitiatorName}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Initiated
                                        Date</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.InitiatedDate}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Intimation
                                        To Name</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.IntimationToName}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Initimation
                                        Date</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.InitimationOn}}</label>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Probation
                                        End Date</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ProbationEndDate}}</label>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Confirmation
                                        Status</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.IsEmpConfirmed}}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Working
                                        Status</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.WorkingStatus}}</label>
                                </div>
                            </div>
                            <div class="row"
                                *ngIf="DetailData.ConfirmationRemark != '' && DetailData.ConfirmationRemark != null">
                                <div class="col-md-3">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Confirmation
                                        Remark</label>
                                </div>
                                <div class="col-md-9">
                                    <label class="form-label"
                                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{DetailData.ConfirmationRemark}}</label>
                                </div>
                            </div>
                            <div class="row" *ngIf="this.GetID == 1">
                                <div class="col-auto">
                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                        style="font-size: 10px;" [disabled]="isDisabled"
                                        (click)="ViewUserAns('E',DetailData.EmpMasterId,DetailData.EmployeeName)">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                            *ngIf="isDisabled"></span>
                                        {{!isDisabled?'View Ans':'Loading...'}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 ps-1">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 p-0">
                            <div class="card">
                                <label class="m-2" *ngIf="!isApprovalLavel">{{tooltip.NoApprovalLevel}}</label>
                                <div class="card-body" *ngIf="isApprovalLavel">
                                    <div id="content">
                                        <ul class="timeline">
                                            <li class="event p-0 m-0" *ngFor="let Tracking of TrackingsUser">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3 class="m-0">
                                                            {{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{Tracking['Status']}}</span>
                                                    </div>
                                                </div>
                                                <label class="date">{{Tracking['ActionDate']}}</label>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                                <input type="text" class="form-control" placeholder="Remark" id="Remark"
                                                    name="Remark" [(ngModel)]="Filter.Remark" #Remark="ngModel"
                                                    [ngClass]="{'is-invalid': this.Filter.isShowError}"
                                                    (change)="removeError()"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1">

                                                <div class="invalid-feedback"
                                                    *ngIf="common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(Tracking['Status']) == 'pending' && GetID == 1 && this.Filter.isShowError">
                                                    Please Enter Remark!
                                                </div>
                                                <hr />
                                            </li>
                                            <li class="event p-0 m-0" *ngFor="let Tracking of Trackings">
                                                <div class="row align-items-center">
                                                    <div class="col-2">
                                                        <img *ngIf="Tracking['Photo'] != null && Tracking['Photo'] != ''"
                                                            mat-card-image class="userImage"
                                                            [src]="common.PhotoLink(Tracking['Photo'])" />
                                                        <div *ngIf="Tracking['Photo'] == null || Tracking['Photo'] == ''"
                                                            class="initial-image">
                                                            <div class="image">
                                                                {{common.getInitial(Tracking['ApproverName'])}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h3>{{Tracking['ApproverName']}}({{Tracking['ApprovalStage']}})
                                                        </h3>
                                                    </div>
                                                    <div class="col-auto"><span class="badge"
                                                            [ngClass]="{'success': (common.ToLowerCase(Tracking['Status']) == 'approved' || common.ToLowerCase(Tracking['Status']) == 'autoapproved'), 'danger':common.ToLowerCase(Tracking['Status']) == 'rejected','warning':common.ToLowerCase(Tracking['Status']) == 'pending' || common.ToLowerCase(Tracking['Status']) == 'reInitiated'}">{{StatusReplace(Tracking['Status'])}}</span>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <label class="date">{{Tracking['ActionDate']}}</label>
                                                    </div>
                                                    <div class="col-auto"
                                                        *ngIf="common.ToLowerCase(Tracking['Status']) != 'pending'">
                                                        <button type="button" class="btn btn-outline-primary btn-sm"
                                                            style="font-size: 10px;" [disabled]="isDisabled"
                                                            (click)="ViewUserAns('A',Tracking['ApproverId'],Tracking['ApproverName'])">
                                                            <span class="spinner-border spinner-border-sm" role="status"
                                                                aria-hidden="true" *ngIf="isDisabled"></span>
                                                            {{!isDisabled?'View Ans':'Loading...'}}</button>
                                                    </div>
                                                </div>
                                                <p class="remark">{{Tracking['Remark']}}</p>
                                            </li>
                                            <li class="event p-0 m-0">
                                                <div class="row">
                                                    <h3>Submitted on</h3>
                                                </div>
                                                <label class="date">{{DetailData.RequestDate}}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row g-0 mt-2">
            <div class="col-md-6">
                <form name="ConfirmationForm" #ConfirmationForm="ngForm">
                    <div class="row" class="g-0" *ngIf="Datas.length > 0">
                        <div class="card mx-1">
                            <div class="card-header">
                                Confirmation Form - {{this.DataEmpName}}
                            </div>
                            <div class="card-body p-0 m-2">
                                <div class="col-md-12" *ngFor="let Data of Datas; let i = index">
                                    <span class="text-label-dark16500">{{Data.QuestionGroupName}}</span>
                                    <div class="row my-2" style="--bs-gutter-x: 0">
                                        <div class="col-md-2">
                                            <span class="text-label">Question {{i + 1}}:</span>
                                        </div>
                                        <div class="col-md-8">
                                            <span class="text-label">{{Data.Questions}}</span>
                                            <span class="text-label-light"
                                                *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">(1
                                                Being Lowest & 5 Being Highest)</span>
                                        </div>
                                    </div>
                                    <div class="row" style="--bs-gutter-x: 0">
                                        <div class="col-md-2">
                                            <span class="text-label">Answer:</span>
                                        </div>
                                        <div class="col-md-8" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 't'">
                                            <textarea rows=2 class="form-control" name="answer{{i}}"
                                                [(ngModel)]="Data.Answer" #answer{{i}}="ngModel" required
                                                [disabled]="
                                                !(((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                                                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)))"></textarea>
                                            <div class="invalid-feedback">
                                                Please enter answer !
                                            </div>
                                        </div>
                                        <div class="col-md-3" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                                            <input name="rating{{i}}" type="text" [(ngModel)]="Data.Score"
                                                class="form-control" minlength="1" maxlength="1" placeholder="Rating"
                                                required [disabled]="!(((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)))"
                                                onkeypress="return event.charCode >= 49 && event.charCode <= 53" />
                                            <div class="invalid-feedback">
                                                Please enter rating between 1 to 5 !
                                            </div>
                                        </div>
                                        <div class="col-md-4 ms-2 text-center"
                                            *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                                            <span class="mandatory-field text-label">Rating between 1 to 5</span>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                                <div class="col-md-12">
                                    <div class="row" style="--bs-gutter-x: 0">
                                        <div class="col-md-2">
                                            <span class="text-label">Final Remark:</span>
                                        </div>
                                        <div class="col-md-8">
                                            <textarea rows=2 class="form-control" name="Remark"
                                                [(ngModel)]="QFilter.Remark" #Remark="ngModel" required [disabled]="!(((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)))"></textarea>
                                            <div class="invalid-feedback">
                                                Please enter final remark !
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-6" *ngIf="DatasView.length > 0">
                <div class="row" class="g-0">
                    <div class="card mx-1">
                        <div class="card-header">
                            Approval Form - {{this.ViewDataEmpName}} - <span class="badge success">{{ViewOfType}}</span>
                        </div>
                        <div class=" card-body p-0 m-2">
                            <div class="col-md-12" *ngFor="let Data of DatasView; let i = index">
                                <span class="text-label-dark16500">{{Data.QuestionGroupName}}</span>
                                <div class="row my-2" style="--bs-gutter-x: 0">
                                    <div class="col-md-2">
                                        <span class="text-label">Question {{i + 1}}:</span>
                                    </div>
                                    <div class="col-md-8">
                                        <span class="text-label">{{Data.Questions}}</span>
                                        <span class="text-label-light"
                                            *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">(1
                                            Being Lowest & 5 Being Highest)</span>
                                    </div>
                                </div>
                                <div class="row" style="--bs-gutter-x: 0">
                                    <div class="col-md-2">
                                        <span class="text-label">Answer:</span>
                                    </div>
                                    <div class="col-md-8" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 't'">
                                        <textarea rows=2 class="form-control" name="answerab{{i}}"
                                            [(ngModel)]="Data.Answer" #answerab{{i}}="ngModel" required
                                            disabled></textarea>
                                        <div class="invalid-feedback">
                                            Please enter answer !
                                        </div>
                                    </div>
                                    <div class="col-md-3" *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                                        <input name="ratingb{{i}}" type="number" [(ngModel)]="Data.Score"
                                            class="form-control" min="1" max="5" placeholder="Rating" required
                                            disabled />
                                        <div class="invalid-feedback">
                                            Please enter rating between 1 to 5 !
                                        </div>
                                    </div>
                                    <div class="col-md-4 ms-2 text-center"
                                        *ngIf="common.ToLowerCase(Data.AnswerIsText) == 's'">
                                        <span class="mandatory-field text-label">Rating between 1 to 5</span>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div class="col-md-12">
                                <div class="row" style="--bs-gutter-x: 0">
                                    <div class="col-md-2">
                                        <span class="text-label">Final Remark:</span>
                                    </div>
                                    <div class="col-md-8">
                                        <textarea rows=2 class="form-control" name="Remarkb" [(ngModel)]="RemarkViewAns"
                                            #Remarkb="ngModel" required disabled></textarea>
                                        <div class="invalid-feedback">
                                            Please enter final remark !
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <div *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                    (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)">

                <ng-select name="DropdownType" [(ngModel)]="DetailData.DropdownType" #DropdownType="ngModel"
                    placeholder="Select Type" [clearable]="false" (change)="SetDateForConfirmatin()">
                    <ng-option [value]=1>Confirm</ng-option>
                    <ng-option [value]=2>Extend</ng-option>
                    <ng-option [value]=3>Terminate</ng-option>
                </ng-select>
            </div>
            <div style="display: inline-flex;" *ngIf="(common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                    (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1)">
                <label for="ConfirmationExtendDateObj" class="form-font-label pe-2 pt-1" style="width: 4rem;"><span
                        class="text-danger">*</span>Date</label>
                <div class="input-group" style="width: 12rem;">
                    <input class="form-control" placeholder="dd-mm-yyyy" name="ConfirmationExtendDateObj"
                        [(ngModel)]="DetailData.ConfirmationExtendDateObj" ngbDatepicker
                        #ConfirmationExtendDateObj="ngbDatepicker" required readonly
                        [minDate]="DetailData.DropdownType == 1?(DetailData.AllowConfirmationBeforeDueDate?DetailData.JoiningDateObj:DetailData.ConfirmationExtendDateMinObj):DetailData.DropdownType == 2?DetailData.ConfirmationExtendDateMinObj:toDayDate"
                        [disabled]="!DetailData.IsManualAllowDate && DetailData.DropdownType != 3" />
                    <button class="btn btn-outline-secondary bi bi-calendar3"
                        (click)="ConfirmationExtendDateObj.toggle()"
                        [disabled]="!DetailData.IsManualAllowDate && DetailData.DropdownType != 3"
                        type="button"></button>
                </div>
                <div class="invalid-feedback">
                    Please select confirmation date!
                </div>
            </div>

            <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="Cancel()"><i
                    class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>

            <button type="button" *ngIf="DetailData.DropdownType == 3 && ((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                    (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1))"
                type="button" class="btn btn-info" [disabled]="isDisabled"
                (click)="Validate(ConfirmationForm,'Reject')"><i class="bi bi-x-octagon" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Terminate':'Loading...'}}</button>

            <button type="button" *ngIf="DetailData.DropdownType == 2 && ((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1))" type="button"
                class="btn btn-warning" [disabled]="isDisabled" (click)="Validate(ConfirmationForm,'Reject')"><i
                    class="bi bi-calendar-range" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Extend':'Loading...'}}</button>

            <button type="button" *ngIf="DetailData.DropdownType == 1 && ((common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && common.ToLowerCase(TrackingsUser.length > 0?TrackingsUser[TrackingsUser.length - 1]['Status']:'') == 'pending' && GetID == 1) || 
                (common.ToLowerCase(DetailData.ApprovalStatus) == 'pending' && isSuper && GetID == 1))" type="button"
                class="btn btn-success" [disabled]="isDisabled" (click)="Validate(ConfirmationForm,'Approve')"><i
                    class="bi bi-check2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Approve':'Loading...'}}</button>
        </div>
    </div>
</div>